var render, staticRenderFns
import script from "./NoContentPage.vue?vue&type=script&lang=tsx"
export * from "./NoContentPage.vue?vue&type=script&lang=tsx"
import style0 from "./NoContentPage.vue?vue&type=style&index=0&id=6728f794&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6728f794",
  null
  
)

export default component.exports